import { meeting } from '@microsoft/teams-js';

import { AcquireTokenAuthError } from '../errors';
import { getAuthToken as getAuthTokenForAADUser } from '../teams';

type GetAuthToken = (resource: string, isAnonymousAuth: boolean, claims?: string[]) => Promise<string>;
export const getAuthToken: GetAuthToken = (resource, isAnonymousAuth, claims) => {
  if (isAnonymousAuth) {
    return getAnonToken();
  }

  return getAuthTokenForAADUser({ resource, claims });
};

type GetAnonToken = () => Promise<string>;
const getAnonToken: GetAnonToken = async () =>
  new Promise((resolve, reject) => {
    meeting.getAuthenticationTokenForAnonymousUser((error, token) => {
      if (error || !token) {
        const errorCode = error?.errorCode || 'AnonAuthAcquireTokenFailed';
        const message = error?.message || `Unable to retrieve a valid auth token: token value is: ${token}`;
        const acquireTokenError = new AcquireTokenAuthError({
          errorCode: 'AnonAuthAcquireTokenFailed',
          errorMessage: JSON.stringify({ errorCode, message }),
        });

        reject(acquireTokenError);

        return;
      }

      resolve(token);
    });
  });
